import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles, Typography } from '@material-ui/core';

import { toLookup, toBoolLookup } from '../../../youwell-common/arrayUtils';
import WeekPlan from './WeekPlan';
import { getLocalDateOnlyString, getSkillWeeks } from './utils';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    week: {
        width: `calc(50% - ${theme.spacing(2)}px)`,
        margin: theme.spacing(1),

        [theme.breakpoints.down('sm')]: {
            width: `calc(100% - ${theme.spacing(2)}px)`,
        },
    },
    weekTitle: {
        marginBottom: theme.spacing(1),
    },
});

class TrainingPlan extends React.Component {
    render() {
        const {
            classes, translate, skill, availableDays, disabled,
        } = this.props;

        if (!skill) {
            return null;
        }

        const { weekArray } = getSkillWeeks(skill);

        const tasksByDate = skill.moduleSchedule ? skill.moduleSchedule.tasks.reduce((prev, curr) => (
            {
                ...prev,
                [getLocalDateOnlyString(curr.date)]: [...prev[getLocalDateOnlyString(curr.date)] || [], curr],
            }
        ), {}) : {};

        const taskNameLookup = skill.module ? toLookup(skill.module.tasks) : { [skill.taskId]: skill.task };
        const availableDaysLookup = toBoolLookup(availableDays);

        return (
            <div className={classes.root}>
                {weekArray.map(week => (
                    <div className={classes.week} key={week.weekNr}>
                        <Typography className={classes.weekTitle}>
                            {`${translate('studentPlan.week')} ${week.weekNr}`}
                        </Typography>
                        <WeekPlan
                            weekStart={week.weekStart}
                            tasks={tasksByDate}
                            taskNames={taskNameLookup}
                            availableDays={availableDaysLookup}
                            disabled={disabled}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

TrainingPlan.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    skill: PropTypes.object.isRequired,
    availableDays: PropTypes.array,
    disabled: PropTypes.bool,
};

TrainingPlan.defaultProps = {
    availableDays: null,
    disabled: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(TrainingPlan));
